"use strict";
exports.__esModule = true;
exports.postProcessing = void 0;
exports.postProcessing = function (item) {
    return {
        id: item.uuid,
        name: item.name,
        assigned: item.PermissionInstance && item.PermissionInstance[0].uuid
    };
};
